/**
 * Mapeia a rota atual para o rótulo de «Seção da Página» do mapa de métricas.
 */
const PATH_TO_SECTION: Record<string, string> = {
  '/portal': 'Home',
  '/boletos': 'Boletos',
  '/notas': 'Notas',
  '/pedido-abastecimento': 'Abastecimento',
  '/pendencias': 'Abastecimento',
  '/tracking': 'Abastecimento',
  '/melhores-horarios': 'Abastecimento',
  '/manutencao': 'Manutenção',
  '/documentacao': 'Documentos técnicos',
  '/documentacao-os': 'Documentos técnicos',
  '/fale-conosco': 'Fale conosco',
  '/perfil': 'Perfil',
  '/nova-empresa': 'Adicionar empresa',
  '/atendimento-comercial': 'Atendimento Comercial',
  '/dicas-seguranca': 'Dicas segurança',
  '/perguntas-frequentes': 'Perguntas frequentes',
};

export function getPageSectionFromPath(pathname?: string): string {
  const path =
    pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  const normalized = path.replace(/\/$/, '') || '/';
  if (normalized === '/portal' || normalized === '/') {
    return 'Home';
  }
  return (
    PATH_TO_SECTION[normalized] ?? path.split('/').filter(Boolean)[0] ?? 'Home'
  );
}
